__turbopack_context__.v({
  "captionopen": "InterventionWidget-module-scss-module__IJ6SUa__captionopen",
  "context": "InterventionWidget-module-scss-module__IJ6SUa__context",
  "explanatory": "InterventionWidget-module-scss-module__IJ6SUa__explanatory",
  "giveButtonWrapper": "InterventionWidget-module-scss-module__IJ6SUa__giveButtonWrapper",
  "grid": "InterventionWidget-module-scss-module__IJ6SUa__grid",
  "header": "InterventionWidget-module-scss-module__IJ6SUa__header",
  "innerParagraphNumber": "InterventionWidget-module-scss-module__IJ6SUa__innerParagraphNumber",
  "input": "InterventionWidget-module-scss-module__IJ6SUa__input",
  "inputWrapper": "InterventionWidget-module-scss-module__IJ6SUa__inputWrapper",
  "output": "InterventionWidget-module-scss-module__IJ6SUa__output",
  "paragraphNumber": "InterventionWidget-module-scss-module__IJ6SUa__paragraphNumber",
  "paragraphWrapper": "InterventionWidget-module-scss-module__IJ6SUa__paragraphWrapper",
  "select": "InterventionWidget-module-scss-module__IJ6SUa__select",
  "selected": "InterventionWidget-module-scss-module__IJ6SUa__selected",
  "spinnerWrapper": "InterventionWidget-module-scss-module__IJ6SUa__spinnerWrapper",
  "wrapper": "InterventionWidget-module-scss-module__IJ6SUa__wrapper",
});
